import StatusBar from 'components/common/StatusBar';
import { ServiceAgreementV2 } from 'pco-product-service-internal-consumer';

interface ActivationStatusProps {
  serviceAgreement: ServiceAgreementV2;
}

const ActivationStatus = ({ serviceAgreement }: ActivationStatusProps) => {
  return serviceAgreement?.macroStepList ? (
    <StatusBar
      data-testid="product-service-role-configuration-partner-not-found-text-area"
      macroStepList={serviceAgreement?.macroStepList}
    />
  ) : null;
};

export default ActivationStatus;
